"use strict";

import {Modal, Toast} from 'bootstrap';
import Cookies from 'js-cookie';
let $ = jQuery;

if ( document.querySelector('.toast') && !Cookies.get('cookiesAccepted') ) {
    let toast = new Toast(document.querySelector('.toast'), {autohide: false});
    toast.show();
    document.getElementById('cookieNoticeAccept').addEventListener('click', () => {
        Cookies.set('cookiesAccepted', true, { expires: 30 });
        toast.hide();
    });
}

// if (document.getElementById('landingModal') && !Cookies.get('landingClosed') ) {
//     $(window).on('load', function() {
//         var myModal = new Modal(document.getElementById('landingModal'), {});
//         myModal.show();
//         document.querySelectorAll('#landingModal .soc-btn').forEach(el => el.addEventListener('click', () => {
//             Cookies.set('landingClosed', true, { expires: 30 });
//         }));
//         document.getElementById('landingBtnClose').addEventListener('click', () => {
//             Cookies.set('landingClosed', true, { expires: 30 });
//             myModal.hide();
//         });
//
//     });
// }

/* Add Idea Modal | functionality
-------------------------------------------------------------------*/
(function( $ ) {
    document.addEventListener( 'yadroCf7AjaxLoaded', () => {
        const addIdeaForms = document.querySelectorAll( '.std-form-popup' );

        addIdeaForms.forEach( (ideaModal, index) => {

            const fileUploadLabel = ideaModal.querySelector( '.std-form-popup-input-file-label' );

            if ( ! fileUploadLabel ) return;

                const labelText = fileUploadLabel.innerHTML
                const fileInput = fileUploadLabel.parentElement.querySelector( 'input' )

                // change label "for" and input "id" attributes
                // needed if we use multiple times the same CF7 form on the same page
                fileUploadLabel.setAttribute( 'for', fileUploadLabel.getAttribute( 'for' ) + `-${index}` );
                fileInput.setAttribute( 'id', fileInput.getAttribute( 'id' ) + `-${index}` );

                function basicFunctionality (e) {
                    e.preventDefault();
                    e.stopPropagation();

                    if ( ['dragenter', 'dragover'].includes( e.type ) ) {
                        fileUploadLabel.classList.add('active');
                    } else {
                        fileUploadLabel.classList.remove('active');
                    } // IF
                } // FNC

                // Prevent default drag behaviors and highlight input area
                ['dragenter', 'dragover', 'dragleave', 'drop'].forEach( eventName => {
                    fileUploadLabel.addEventListener( eventName, basicFunctionality, false )
                } );

                // Handle dropped files
                fileUploadLabel.addEventListener( 'drop', (e) => {
                    const file = e.dataTransfer.files;

                    // Now let's create a DataTransfer to get a FileList
                    const dataTransfer = new DataTransfer();
                    dataTransfer.items.add(file[0]);
                    fileInput.files = dataTransfer.files;

                    // trigger change event to change text in the Label
                    fileInput.dispatchEvent( new CustomEvent( 'change' ) );
                }, false );

                // change text when file input have changes from user
                fileInput.addEventListener( 'change', (e) => {

                    fileUploadLabel.innerHTML = fileInput.files.length ? fileInput.files[0].name : labelText;

                }, false );

        } ); // EACH


    } ); // addEventListener


})( jQuery );